import React, { useState } from "react";
import axios from "axios";
import s from "../styles/UploadExcel.module.css";

const UploadExcel = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [duplicate, setDuplicate] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
    setError("");
    setDuplicate("");
  };

  const handleUpload = async () => {
    if (!file) {
        setMessage("");
       
        setDuplicate("");
      setError("Выберите файл для загрузки!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
        setMessage("");
      setError("");
      setDuplicate("");

      const response = await axios.post("/excel/upload-excel", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMessage(response.data.message);
      setError(response.data.errors_vin);
      setDuplicate(response.data.duplicates_vin);
    //   setFile(null);
    } catch (err) {
      setError(err.response?.data?.error || "Ошибка загрузки");
    }
  };

  return (
    <div className={s.container}>
      <p>Загрузка Excel-файла</p>
      <input className={s.input_up_exel} type="file" onChange={handleFileChange} accept=".xlsx" />
      <button className={s.add_excel_button} onClick={handleUpload}>Загрузить</button>
      {message && <p className={s.success}>{message}</p>}
      {error && <p className={s.error}>{error}</p>}
      {duplicate && <p className={s.error}>{duplicate}</p>}
    </div>
  );
};

export default UploadExcel;
